// extracted by mini-css-extract-plugin
export default {"box":"PerfilUsuario_box__-7WUn","imagen":"PerfilUsuario_imagen__VNOME"};